/** Production hostnames: gcx.app, gcx.app */
export const PRODUCTION_HOSTNAMES = ["gcx.raise.com", "gcx.app"];

/** Sandbox/staging hostnames: gcx.raisestaging.com, gcx-staging.app */
export const SANDBOX_HOSTNAMES = ["gcx.raisestaging.com", "gcx-staging.app"];

export const isProductionDomain = (hostname) =>
  PRODUCTION_HOSTNAMES.some(
    (h) => hostname === h || hostname.endsWith(`.${h}`)
  );

export const isSandboxDomain = (hostname) =>
  SANDBOX_HOSTNAMES.some(
    (h) => hostname === h || hostname.endsWith(`.${h}`)
  );
